<template>
    <div class="gisInfo" style="color: #fff">
        <div>
            <div id="map"></div>
            <div v-if="isGis" style="color: #adadad;margin:1rem 0;font-size: 1rem;">
                <div style="display: flex;align-items: center;justify-content: space-between;">
                    <div class="zoom-tip"><span>项目：</span><span>{{proInfo.projectName}}</span></div>
                    <div class="zoom-tip" v-if="renderDetail && renderDetail.code">
                        <div class="detail-item">
                            <div class="label">编号</div>
                            <div class="value">{{ renderDetail.code }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">材质</div>
                            <div class="value">{{ renderDetail.material }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">管长(m)</div>
                            <div class="value">{{ renderDetail.length }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">管径(mm)</div>
                            <div class="value">{{ renderDetail.diameter }}</div>
                        </div>
                    </div>
                </div>
                <span style="font-size: 1.1rem;">请点击地图中一个管段！</span>
            </div>
            <ButtonField style="float: right;" text="确定" v-if="renderDetail && renderDetail.code && isGis" primary @click="handleMap"/>
        </div>
        <div  v-if="currentGisShow">
            <div class="tieIn1" style="display: block">
                <div class="tieIn-content">
                    <div style="color: #adadad;margin:1rem 0;font-size: 1rem;">
                        <div style="display: flex;align-items: center;justify-content: space-between;">
                            <div class="zoom-tip"><span>项目：</span><span>{{proInfo.projectName}}</span></div>
                            <div class="zoom-tip" v-if="renderDetail && renderDetail.code">
                                <div class="detail-item">
                                    <div class="label">编号</div>
                                    <div class="value">{{ renderDetail.code }}</div>
                                </div>
                                <div class="detail-item">
                                    <div class="label">材质</div>
                                    <div class="value">{{ renderDetail.material }}</div>
                                </div>
                                <div class="detail-item">
                                    <div class="label">管长(m)</div>
                                    <div class="value">{{ renderDetail.length }}</div>
                                </div>
                                <div class="detail-item">
                                    <div class="label">管径(mm)</div>
                                    <div class="value">{{ renderDetail.diameter }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form>
                        <div class="tieIn-title1">
                            <div style="display: flex;justify-content: space-between;">
                                <SelectField style="margin: 0.5rem auto;width: 48%;" label="管段类型" id="pipeType"
                                             :modelValue="form.pipeType" :options="pipeTypes" labelWidth="60%"
                                             @update:modelValue="(value) => handleModelValueUpdate('pipeType', value)"
                                />
                                <SelectField style="margin: 0.5rem auto;width: 48%;" label="检测方向" id="detDirection"
                                             :modelValue="form.detDirection" :options="detDirections" labelWidth="60%"
                                             @update:modelValue="(value) => handleModelValueUpdate('detDirection', value)"
                                />
                            </div>
                            <div style="margin-bottom: 1rem;display: flex;justify-content: space-between;">
                                <InputField label="修复指数" type="text" id="repairIndex" style="margin: 0.5rem auto;width: 48%;"
                                            label-width="60%" :modelValue="form.repairIndex" placeholder="请输入修复指数"
                                            @update:modelValue="(value) => handleModelValueUpdate('repairIndex', value)"
                                />
                                <DatePickerField labelWidth="60%" label="检测日期" style="margin: 0.5rem auto;width: 48%;"
                                                 name="testDate" placeholder="请选择检测日期"
                                                 :modelValue="form.testDate" id="testDate"
                                                 @update:modelValue="(value) => handleModelValueUpdate('testDate', value)"
                                />
                            </div>
                        </div>
                        <div class="tieIn-title1">
                            <div class="tieIn-title-name">结构性缺陷</div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="结构性缺陷" id="structGrade" placeholder="请选择结构性缺陷" inputDivWidth="79%"
                                              :modelValue="form.structGrade" :options="pipeDefectList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('structGrade', value)"
                                />
                            </div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="管段修复" id="structRepair" placeholder="请选择管段修复" inputDivWidth="79%"
                                              :modelValue="form.structRepair" :options="repairIndexList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('structRepair', value)"
                                />
                            </div>
                            <div class="tieIn-title-name">功能性缺陷</div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="功能性缺陷" id="alityGrade" placeholder="请选择功能性缺陷" inputDivWidth="79%"
                                              :modelValue="form.alityGrade" :options="functionDefectList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('alityGrade', value)"
                                />
                            </div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="管段养护" id="alityRepair" placeholder="请选择管段养护" inputDivWidth="79%"
                                              :modelValue="form.alityRepair" :options="pipeSectionList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('alityRepair', value)"
                                />
                            </div>
                        </div>
                        <div class="tieIn-content-form">
                        </div>
                    </form>
                </div>
                <div class="tieIn-button">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                        <Upload :list="fileList" @change="onUpload" />
                    </a-space>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import area from "@/mixins/area";
import sewageScope from "./mixins/sewage-scope";
import sewagePipe from "./mixins/sewage-pipe";
import sewageWell from "./mixins/sewage-well";
import facility from "./mixins/facility";
import rainPipe from "./mixins/rain-pipe";
import rainWell from "./mixins/rain-well";
import rainDrain from "./mixins/rain-drain";

import { Scene } from "@antv/l7";
import { GaodeMapV2 } from "@antv/l7-maps";
import { debounce } from "lodash";
import sourceMixin from "./mixins/source";
import connectMixin from "./mixins/connect";
import { mapMutations,mapActions } from "vuex";
import { getCenterPoint, getAngle } from "@/utils/map";
import { fetchPipeDetail as fetchRainPipeDetail } from "@/views/gis/api/rain";
import { fetchPipeDetail as fetchSewagePipeDetail } from "@/views/gis/api/sewage";
export default {
    components: {},
    mixins: [
        area,
        sewagePipe,
        sewageWell,
        sewageScope,
        rainPipe,
        rainWell,
        rainDrain,
        sourceMixin,
        connectMixin,
        facility,
    ],
    computed: {
        toolBarStyle() {
            if (this.isSidebarCollapsed) {
                return { top: '11vh', left: '5vw',};
            } else {
                return { top: '11vh', left: '335px',};
            }
        },
        toolBarStyle1() {
            if (this.isSidebarCollapsed) {
                return { bottom: '40px', left: '5vw',};
            } else {
                return { bottom: '40px', left: '335px',};
            }
        },
    },
    props:{
        pipeInfo: {
            type: Object,
            default: () => ({}),
        },
        gisShow:{
            type:Boolean,
            default:true
        },
        proInfo:{
            type:Object,
            default:()=>({})
        }
    },
    data() {
        return {
            pipeTypes:[{name:'污水',value:'污水'},{name:'雨水',value:'雨水'}],
            detDirections:[{name:'顺流',value:'顺流'},{name:'逆流',value:'逆流'}],
            isGis:true,
            currentGisShow: this.gisShow,
            fileList: [],
            form:{},
            renderDetail:{},
            rainpipeDetail:{},
            selected: [],
            pathForAcross: null,
            areaFacilityIdList: [],
            areaFacilityListVisible: false,
            areaVisible: false,
            overlays: [],
            mouseTool: null,
            currentZoom: 14,
            isSidebarCollapsed: false,
            // 新增：标记是否已初始化地图
            isMapInitialized: false,
            // 新增：存储地图相关元素
            mapElements: {
                polyline: null,
                rectangle: null,
                markerForAcross1: null,
                markerForAcross2: null,
                polylineForAcross: null,
                sewagePipeTextList: [],
                rainPipeTextList: []
            },
            pipeDefectList:[
                {name:'Ⅰ等级-无或有轻微缺陷，结构状况基本不受影响，但具有潜在变坏的可能',value:'Ⅰ'},{name:'Ⅱ等级-管段缺陷明显超过一级，具有变坏的趋势',value:'Ⅱ'},
                {name:'Ⅲ等级-管段缺陷严重，结构状况受到影响',value:'Ⅲ'},{name:'Ⅳ等级-管段存在重大缺陷，损坏严重或即将导致破坏',value:'Ⅳ'},
            ],
            repairIndexList:[
                {name:'Ⅰ等级-结构条件基本完好，不修复',value:'Ⅰ'},{name:'Ⅱ等级-结构在短期内不会发生破坏现象，但应做修复计划',value:'Ⅱ'},
                {name:'Ⅲ等级-结构在短期内可能会发生破坏，应尽快修复',value:'Ⅲ'},{name:'Ⅳ等级-结构已经发生或即将发生破坏，应立即修复',value:'Ⅳ'},
            ],
            functionDefectList:[
                {name:'Ⅰ等级-无或有轻微影响，管道运行基本不受影响',value:'Ⅰ'},{name:'Ⅱ等级-管道过流有一定的受阻，运行受影响不大',value:'Ⅱ'},
                {name:'Ⅲ等级-管道过流受阻比较严重，运行受到明显影响',value:'Ⅲ'}, {name:'Ⅳ等级-管道过流受阻很严重，即将或已经导致运行瘫痪',value:'Ⅳ'},
            ],
            pipeSectionList:[
                {name:'Ⅰ等级-没有明显需要处理的缺陷',value:'Ⅰ'},{name:'Ⅱ等级-没有立即进行处理的必要，但宜安排处理计划',value:'Ⅱ'},
                {name:'Ⅲ等级-根据基础数据进行全面的考虑，应尽快处理',value:'Ⅲ'},{name:'Ⅳ等级-输水功能受到严重影响，应立即进行处理',value:'Ⅳ'},
            ]
        };
    },
    watch: {
        gisShow(newVal) {
            this.currentGisShow = !newVal;
        },
        rainpipeDetail:{
            handler(val){
                console.log("val:::::::::",val)
            },
            deep:true
        },
        selected: {
            handler() {
                if (!this.isMapInitialized) return;

                if (this.selected.indexOf("污水管网") > -1) {
                    this.getPipe();
                } else {
                    this.removePipe();
                }

                if (this.selected.indexOf("污水检查井") > -1) {
                    this.getWell();
                } else {
                    this.removeWell();
                }

                if (this.selected.indexOf("污水收集区") > -1) {
                    this.getsewageScope();
                } else {
                    this.removesewageScope();
                }

                if (this.selected.indexOf("雨水管网") > -1) {
                    this.getrainpipe();
                } else {
                    this.removerainpipe();
                }

                if (this.selected.indexOf("雨水排口") > -1) {
                    this.getraindrain();
                } else {
                    this.removeraindrain();
                }

                if (this.selected.indexOf("雨水检查井") > -1) {
                    this.getrainwell();
                } else {
                    this.removerainwell();
                }

                if (this.selected.indexOf("截流设施") > -1) {
                    this.getCuto();
                } else {
                    this.removeCuto();
                }

                if (this.selected.indexOf("液位计") > -1) {
                    this.getLiquid();
                } else {
                    this.removeLiquid();
                }

                if (this.selected.indexOf("流量计") > -1) {
                    this.getFlow();
                } else {
                    this.removeFlow();
                }

                if (this.selected.indexOf("雨量计") > -1) {
                    this.getRainfall();
                } else {
                    this.removeRainfall();
                }

                if (this.selected.indexOf("水质监测站") > -1) {
                    this.getWaterQuality();
                } else {
                    this.removeWaterQuality();
                }

                if (this.selected.indexOf("视频监控") > -1) {
                    this.getMonitor();
                } else {
                    this.removeMonitor();
                }
            },
            deep: true,
        },
        selectedWellType() {
            if (!this.isMapInitialized) return;

            this.wellList?.forEach((item) => {
                if (this.selectedWellType.find((type) => type === item.type)) {
                    item.layer.show();
                } else {
                    item.layer.hide();
                }
            });
        },
        selectedrainwellType() {
            if (!this.isMapInitialized) return;

            this.rainwellList?.forEach((item) => {
                if (this.selectedrainwellType.find((type) => type === item.type)) {
                    item.layer.show();
                } else {
                    item.layer.hide();
                }
            });
        },
    },
    mounted() {
        this.debounceZoomChange = debounce(this.onZoomChange, 150);
        this.debounceMoveend = debounce(this.onMoveEnd, 150);
        this.initMap();
    },
    beforeDestroy() {
        this.destroyMap();
    },
    methods: {
        ...mapMutations('gis', ['setRainpipeDetail']),
        ...mapActions("home", ["getFacilityList"]),
        onUpload(val) {
            this.fileList = val;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        handleMap() {
            this.currentGisShow = true;
            this.isGis = false;
            console.log("this.currentGisShow ",!this.currentGisShow )
            this.destroyMap();
        },
        destroyMap() {
            if (!this.isMapInitialized) return;
            console.log("===== destroyMap =====")

            // 1. 先隐藏地图容器
            const mapContainer = document.getElementById('map');
            if (mapContainer) {
                mapContainer.style.display = 'none';
            }

            // 2. 清除地图事件监听
            if (this.map) {
                this.map.off("click", this.onMapClick);
                this.map.off("click", this.onMapClick1);
                this.map.off("zoomend", this.debounceZoomChange);
                this.map.off("moveend", this.debounceMoveend);
            }

            // 清除覆盖物
            if (this.mapElements.polyline) {
                this.mapElements.polyline.remove();
                this.mapElements.polyline = null;
            }
            if (this.mapElements.rectangle) {
                this.mapElements.rectangle.remove();
                this.mapElements.rectangle = null;
            }
            if (this.mapElements.markerForAcross1) {
                this.mapElements.markerForAcross1.remove();
                this.mapElements.markerForAcross1 = null;
            }
            if (this.mapElements.markerForAcross2) {
                this.mapElements.markerForAcross2.remove();
                this.mapElements.markerForAcross2 = null;
            }
            if (this.mapElements.polylineForAcross) {
                this.mapElements.polylineForAcross.remove();
                this.mapElements.polylineForAcross = null;
            }

            // 清除文本标注
            this.clearPipeText("sewage");
            this.clearPipeText("rain");

            // 清除图层相关引用
            if (this.wellList?.length > 0) {
                this.wellList.forEach((item) => {
                    if (item.layer && typeof item.layer.destroy === 'function') {
                        try {
                            item.layer.destroy();
                        } catch (error) {
                            console.warn("Error destroying well layer:", error);
                        }
                    }
                    item.markers?.forEach((marker) => {
                        if (marker) {
                            marker.off("click", this.onWellClick);
                            marker.remove();
                        }
                    });
                });
            }

            if (this.drainList?.length > 0) {
                this.drainList.forEach((item) => {
                    if (item) {
                        item.off("click", this.onDrainClick);
                        item.remove();
                    }
                });
                if (this.drainLabelsLayer && typeof this.drainLabelsLayer.destroy === 'function') {
                    try {
                        this.drainLabelsLayer.destroy();
                    } catch (error) {
                        console.warn("Error destroying drain layer:", error);
                    }
                }
            }

            // 清除其他图层
            this.pipeLayer?.destroy();
            this.pipeLayer2?.destroy();
            this.activePipeLayer?.destroy();
            this.rainpipeLayer?.destroy();
            this.rainpipeLayer2?.destroy();
            this.activerainpipeLayer?.destroy();

            // 4. 清空地图容器内容
            if (mapContainer) {
                mapContainer.innerHTML = '';
            }

            // 5. 销毁地图实例和场景
            if (this.scene) {
                this.scene.destroy();
                this.scene = null;
            }

            if (this.map) {
                this.map.destroy();
                this.map = null;
            }

            // 6. 销毁鼠标工具
            if (this.mouseTool) {
                this.mouseTool.close();
                this.mouseTool = null;
            }

            // 7. 重置状态
            this.isMapInitialized = false;

            // 8. 强制垃圾回收
            if (window.gc) {
                window.gc();
            }
        },
        getSewageDetail(detail){
            fetchSewagePipeDetail({
                ids: [detail.id],
                type: "sewage",
            }).then((res) => {
                if (Array.isArray(res) && res.length > 0) {
                    const item = res[0];
                    this.renderDetail = {
                        ...item,
                        pipeFrom:
                            item.pipesFrom && item.pipesFrom[0] ? item.pipesFrom[0] : null,
                        pipeTo: item.pipesTo && item.pipesTo[0] ? item.pipesTo[0] : null,
                    };

                    console.log("this.renderDetail:::::",this.renderDetail)
                }
            });
        },
        getDetail(detail) {
            fetchRainPipeDetail({
                ids: [detail.id],
                type: "rain",
            }).then((res) => {
                if (Array.isArray(res) && res.length > 0) {
                    const item = res[0];
                    this.renderDetail = {
                        ...item,
                        pipeFrom:
                            item.pipesFrom && item.pipesFrom[0] ? item.pipesFrom[0] : null,
                        pipeTo: item.pipesTo && item.pipesTo[0] ? item.pipesTo[0] : null,
                    };

                    console.log("this.renderDetail:::::",this.renderDetail)
                }
            });
        },
        updateRainPipeDetail(detail,typeInfo) {
            console.log("updateRainPipeDetail:::",detail)
            if( typeInfo == 'rain'){
                this.getDetail(detail);
            }else{
                this.getSewageDetail(detail);
            }
            this.rainpipeDetail = detail;

        },
        handleSidebarToggle(isCollapsed) {
            this.isSidebarCollapsed = isCollapsed;
        },
        initMap() {
            // 如果已经初始化，先销毁
            if (this.isMapInitialized) {
                this.destroyMap();
            }

            const { AMap } = window;
            if (!AMap) {
                console.error("AMap is not loaded");
                return;
            }

            try {
                // 创建地图实例
                const map = new AMap.Map("map", {
                    viewMode: "3D",
                    terrain: true,
                    center: [118.536766,32.993047],
                    zoom: 14,
                    mapStyle: "amap://styles/light",
                    WebGLParams: {
                        preserveDrawingBuffer: true,
                    },
                });

                // 加载地图插件
                AMap.plugin(
                    [
                        "AMap.Scale",
                        "AMap.HawkEye",
                        "AMap.MapType",
                        "AMap.PolygonEditor",
                        "AMap.MouseTool",
                    ],
                    () => {
                        this.mouseTool = new AMap.MouseTool(map);
                        this.overlays = [];
                        this.mouseTool.on("draw", (e) => {
                            this.overlays.push(e.obj);
                        });
                    }
                );

                // 创建场景
                this.scene = new Scene({
                    id: "map",
                    logoVisible: false,
                    map: new GaodeMapV2({
                        mapInstance: map,
                    }),
                });

                this.scene.on("loaded", () => {
                    this.getFacilityList();
                    this.scene.addImage("sewageWell", "/icon/sewage-well-active.png");
                    this.scene.addImage("rainWell", "/icon/rain-well-active.png");
                });

                // 设置地图事件监听
                map.on("zoomend", this.debounceZoomChange);
                map.on("moveend", this.debounceMoveend);

                // 根据pipeInfo设置点击事件
                if(this.pipeInfo && this.pipeInfo.code){
                    this.onMapClick();
                }else{
                    map.on("click", this.onMapClick1);
                }

                this.map = map;
                this.isMapInitialized = true;

                // 设置初始选中项
                this.selected = [
                    "污水收集区",
                    "污水管网",
                    "污水检查井",
                    "雨水管网",
                    "雨水排口",
                    "雨水检查井",
                    "截流设施",
                    "流量计",
                    "液位计",
                    "雨量计",
                    "水质监测站",
                    "视频监控",
                ];
            } catch (error) {
                console.error("Failed to initialize map:", error);
                this.isMapInitialized = false;
            }
        },
        onMoveEnd() {
            if (!this.isMapInitialized || this.currentZoom < 16.7) return;

            const center = this.map?.getCenter();
            if (!center) return;

            let path = [
                [center.lng + 0.01, center.lat + 0.01],
                [center.lng + 0.01, center.lat - 0.01],
                [center.lng - 0.01, center.lat + 0.01],
                [center.lng - 0.01, center.lat - 0.01],
            ];

            const { AMap } = window;
            this.clearPipeText();

            // 处理污水管网文本
            this.mapElements.sewagePipeTextList = [];
            if (this.selected.indexOf("污水管网") > -1) {
                for (let i = 0; i < this.sewagePipeRawList.length; i++) {
                    const item = this.sewagePipeRawList[i];
                    if (!item[5]) continue;

                    const flag =
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[1]), parseFloat(item[2])],
                            path
                        ) ||
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[3]), parseFloat(item[4])],
                            path
                        );
                    if (!flag) continue;

                    const point = getCenterPoint(
                        item[1] + "," + item[2],
                        item[3] + "," + item[4]
                    );
                    if (!point.lng) continue;

                    const angleValue = getAngle(
                        parseFloat(item[1]),
                        parseFloat(item[2]),
                        parseFloat(item[3]),
                        parseFloat(item[4])
                    );

                    const text = new AMap.Text({
                        text: item[6] + "/DN" + item[5],
                        zIndex: 500,
                        zooms: [18, 20],
                        anchor: "center",
                        angle: angleValue,
                        offset: [16, 16],
                        style: {
                            "text-align": "center",
                            "font-size": "8px",
                            color: "#e89915",
                            background: "transparent",
                            "border-width": 0,
                        },
                        position: [point.lng, point.lat],
                    });
                    this.mapElements.sewagePipeTextList.push(text);
                }
            }

            if (this.mapElements.sewagePipeTextList.length > 0) {
                this.map.add(this.mapElements.sewagePipeTextList);
            }

            // 处理雨水管网文本
            this.mapElements.rainPipeTextList = [];
            if (this.selected.indexOf("雨水管网") > -1) {
                for (let i = 0; i < this.rainPipeRawList.length; i++) {
                    const item = this.rainPipeRawList[i];
                    const flag =
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[1]), parseFloat(item[2])],
                            path
                        ) ||
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[3]), parseFloat(item[4])],
                            path
                        );
                    if (!flag) continue;

                    const point = getCenterPoint(
                        item[1] + "," + item[2],
                        item[3] + "," + item[4]
                    );
                    if (!point.lng) continue;

                    const angleValue = getAngle(
                        parseFloat(item[1]),
                        parseFloat(item[2]),
                        parseFloat(item[3]),
                        parseFloat(item[4])
                    );

                    const text = new AMap.Text({
                        text: item[6] + "/DN" + item[5],
                        zIndex: 500,
                        zooms: [18, 20],
                        anchor: "center",
                        angle: angleValue,
                        offset: [16, 16],
                        style: {
                            "text-align": "center",
                            "font-size": "8px",
                            color: "#00ffff",
                            background: "transparent",
                            "border-width": 0,
                        },
                        position: [point.lng, point.lat],
                    });
                    this.mapElements.rainPipeTextList.push(text);
                }
            }

            if (this.mapElements.rainPipeTextList.length > 0) {
                this.map.add(this.mapElements.rainPipeTextList);
            }
        },
        clearPipeText(type) {
            if (!this.isMapInitialized) return;

            if (type === "sewage" || !type) {
                if (this.mapElements.sewagePipeTextList && this.mapElements.sewagePipeTextList.length > 0) {
                    this.map.remove(this.mapElements.sewagePipeTextList);
                    this.mapElements.sewagePipeTextList = [];
                }
            }
            if (type === "rain" || !type) {
                if (this.mapElements.rainPipeTextList && this.mapElements.rainPipeTextList.length > 0) {
                    this.map.remove(this.mapElements.rainPipeTextList);
                    this.mapElements.rainPipeTextList = [];
                }
            }
        },
        onZoomChange() {
            if (!this.isMapInitialized) return;

            this.changeSewageScopeSize();

            const zoom = this.map?.getZoom() || 3;
            this.currentZoom = zoom;

            if (zoom >= 16.7) {
                console.log("设置管线文本标注");
                this.onMoveEnd();
            } else {
                this.clearPipeText();
            }

            if (zoom >= 16.7) {
                this.getWell();
                this.getrainwell();
            } else {
                this.removeWell();
                this.removerainwell();
            }

            this.cutoLayer?.size(zoom * 0.55);
            this.liquidLayer?.size(zoom * 0.55);
            this.flowLayer?.size(zoom * 0.55);
            this.rainfallLayer?.size(zoom * 0.55);
            this.waterQualityLayer?.size(zoom * 0.55);
            this.monitorLayer?.size(zoom * 0.55);
            this.facilityActiveLayer?.size(zoom * 0.6);

            this.sewageWellLayer?.size(zoom * 0.55);
            this.rainWellLayer?.size(zoom * 0.55);

            this.raindrainLayer?.size(zoom * 0.55);

            // 调整地图大小和视角
            if (zoom >= 20) {
                this.pipeLayer?.size(3);
                this.pipeLayer2?.size(3);
                this.rainpipeLayer?.size(3);
                this.rainpipeLayer2?.size(3);
                this.map.setPitch(20, true);
            } else {
                this.pipeLayer?.size(1);
                this.pipeLayer2?.size(1);
                this.rainpipeLayer?.size(1);
                this.rainpipeLayer2?.size(1);
                this.map.setPitch(0, true);
            }
        },
        onMapClick() {
            if (!this.isMapInitialized) return;

            const { AMap } = window;
            if (!AMap) return;

            // 检查是否提供了 pipeInfo
            if (!this.pipeInfo || !this.pipeInfo.xfrom || !this.pipeInfo.yfrom || !this.pipeInfo.xto || !this.pipeInfo.yto) {
                this.$message.error("pipeInfo 数据不完整");
                return;
            }

            // 解析 pipeInfo 中的坐标
            const xfrom = parseFloat(this.pipeInfo.xfrom);
            const yfrom = parseFloat(this.pipeInfo.yfrom);
            const xto = parseFloat(this.pipeInfo.xto);
            const yto = parseFloat(this.pipeInfo.yto);

            console.log("xfrom::", xfrom, "   yfrom::", yfrom);
            console.log("xto::", xto, "    yto:::", yto);

            // 定位地图中心到 xfrom, yfrom 并放大
            this.map.setCenter(new AMap.LngLat(xfrom, yfrom));
            this.map.setZoom(20);

            // 清除之前绘制的图形
            if (this.mapElements.polyline) {
                this.mapElements.polyline.remove();
                this.mapElements.polyline = null;
            }
            if (this.mapElements.rectangle) {
                this.mapElements.rectangle.remove();
                this.mapElements.rectangle = null;
            }

            // 创建矩形框
            const bounds = new AMap.Bounds(
                new AMap.LngLat(Math.min(xfrom, xto), Math.min(yfrom, yto)),
                new AMap.LngLat(Math.max(xfrom, xto), Math.max(yfrom, yto))
            );

            this.mapElements.rectangle = new AMap.Rectangle({
                bounds: bounds,
                strokeColor: '#ff0000',
                strokeWeight: 3,
                strokeOpacity: 0.8,
                fillOpacity: 0.35,
                zIndex: 500
            });

            this.map.add(this.mapElements.rectangle);
        },
        onMapClick1(e) {
            if (!this.isMapInitialized || this.controlType !== "across") return;

            const { AMap } = window;
            const lng = e.lnglat.getLng();
            const lat = e.lnglat.getLat();

            if (!this.mapElements.markerForAcross1) {
                this.mapElements.markerForAcross1 = new AMap.Marker({
                    position: new AMap.LngLat(lng, lat),
                });
                this.map.add(this.mapElements.markerForAcross1);
                this.$message.info("请点击管线另一侧");
                return;
            }

            if (!this.mapElements.markerForAcross2) {
                this.mapElements.markerForAcross2 = new AMap.Marker({
                    position: new AMap.LngLat(lng, lat),
                });
                this.map.add(this.mapElements.markerForAcross2);

                console.log("getPosition1", this.mapElements.markerForAcross1.getPosition());
                console.log("getPosition2", this.mapElements.markerForAcross2.getPosition());

                this.pathForAcross = [
                    this.mapElements.markerForAcross1.getPosition(),
                    this.mapElements.markerForAcross2.getPosition(),
                ];

                this.mapElements.polylineForAcross = new AMap.Polyline({
                    path: this.pathForAcross,
                    borderWeight: 2,
                    strokeColor: "red",
                    lineJoin: "round",
                });

                this.map.add(this.mapElements.polylineForAcross);
            }
        },
        handleSubmit(){
            console.log("handleSubmit    this.renderDetail:::::", this.renderDetail)
            this.form.pointFrom =  this.renderDetail.pointFrom;
            this.form.pointTo =  this.renderDetail.pointTo;
            this.form.elevationFrom =  this.renderDetail.elevationFrom;
            this.form.elevationTo =  this.renderDetail.elevationTo;
            this.form.buringDepthFrom =  this.renderDetail.buringDepthFrom;
            this.form.buringDepthTo =  this.renderDetail.buringDepthTo;
            this.form.material =  this.renderDetail.material;
            this.form.diameter =  this.renderDetail.diameter;
            this.form.length =  this.renderDetail.length;
            this.form.location =  this.renderDetail.location;
            this.form.code =  this.renderDetail.code;
            this.form.pipeId =  this.renderDetail.id;
            console.log("handleSubmit    this.form:::::", this.form)
            this.fileList = []
            if(this.fileList.length > 0){
                this.form.videoUrl = this.fileList.map(file => file.completePath).join(';');
            }

            this.form.defectId = this.proInfo.id;
            console.log("proInfo:::",this.proInfo)
            console.log("this.form::::",this.form)
            this.$emit('save', this.form);
            this.$emit("cancel",false);
        },
        cancel(){
            this.currentGisShow = false;
            this.$emit("cancel",false)
        }
    },
};
</script>

<style lang="less" scoped>
.gisInfo{
    height: 75vh;
}
#map {
    height: 60vh;

}

.zoom-tip {
    z-index: 100;
    display: flex;
    margin-bottom: 0.5rem;
}
.zoom-tip > div{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem;
}
::v-deep .amap-ctrl-icon-layer,::v-deep  .amap-ctrl-list-layer{
    background-color: #091027;
    border-radius: 3px;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, .2);
    border: 1px solid #065645;
    color: #d7d7d7;
    z-index:20;
}
::v-deep .amap-ctrl-base-layer{
    border-bottom: 1px solid #065645;
}

.submit{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 1rem 0;
}
.zoom-tip{
    color: #adadad;
}

.detail-item {
    display: flex;
    margin-bottom: 0.5rem;
}

.label {
    margin-right: 0.5rem;
    font-weight: bold;
}

.value {
    color: #38a578;
}

.tieIn1{
    color: #fff;
    padding-bottom: 10px;
    background: rgba(0,0,0,0)!important;
}
.tieInInfo{
    display: flex;
    justify-content: space-between;
}
.tieInInfo1{
    margin: 0.5rem 0;
}
.tieInInfo{
    margin: 0.5rem 0;
}
.tieIn-button{
    display: flex;
    justify-content: center;
    margin: 1rem  0;
}
.tieIn-content-form{
    display: flex;
    justify-content:space-between;
}
.tieIn-title{
    color: #00d4ff;
    width: 48%;
}

</style>
